<!-- <p>Default Page</p> -->
<div class="content" role="main" *ngIf="loaded">
	<!-- Prevent the Not Logged in template flashing on load -->
	<br>
	<img src="https://stmgwebappstorage.blob.core.windows.net/branding/PRISMtec.io-150px.png"
		[attr.x-contenttype]="'image/png'" title="PRISMtec.io" />
	<br>
	<!-- Work out which template to show based on logged in status -->
	<ng-container *ngIf="(auth.isAuthenticated$ | async); then loggedIn else NotloggedIn"> </ng-container>
	<!-- <ng-container *ngIf="(auth.isAuthenticated$ | async) && !env.production then debugging"></ng-container> -->
	<ng-container *ngTemplateOutlet="PowerdBy"></ng-container>
</div>

<!-- User Not Logged in -->
<ng-template #NotloggedIn>
	<h2>Welcome to</h2>
	<!-- <h1><app-application-name inputValue="{{sAppName}}" foreColor="black"></app-application-name></h1> -->
	<h1 class="appName" [innerHTML]="sAppName"></h1>
	<br>
	<button mat-flat-button id="qsLoginBtn" color="primary" (click)="auth.loginWithRedirect()">
		<mat-icon>lock</mat-icon>&nbsp;<span>Log in</span>
	</button>
</ng-template>

<!-- User Logged in -->
<ng-template #loggedIn>
	<div id="Content1" class="content alignColumn" style="margin-top: var(--default-margin);">
		<h2>
			<span class="alignColumn" *ngIf="thisUser" style="text-decoration: underline;">
				<span>Welcome&nbsp;{{thisUser.Name}}</span>
				<span>to</span>
			</span>
		</h2>
		<h1 class="appName" [innerHTML]="sAppName"></h1>
	</div>
</ng-template>

<ng-template #debugging>
	<mat-icon class="debugging-button" [matMenuTriggerFor]="userAccountMenu" title="View Debug Info">adb</mat-icon>
	<mat-menu #userAccountMenu="matMenu" [overlapTrigger]="false">
		<ul class="debugging-ul-info">
			<li><b>Security Debugging</b></li>
			<li><b>Domain:</b><br>{{env.auth.domain}}</li>
			<li><b>clientId:</b><br>{{env.auth.clientId}}</li>
			<li><b>audience:</b><br>{{env.auth.audience}}</li>
			<li><b>apiUrl:</b><br>{{env.apiUrl}}</li>
			<li><b>errorPath:</b><br>{{env.auth.errorPath}}</li>
		</ul>
	</mat-menu>
</ng-template>

<ng-template #PowerdBy>
	<span fxShow.gt-height-md class="fixed-bottom-right">
		<span class="text">Powered By</span>
		<img src="https://stmgwebappstorage.blob.core.windows.net/branding/Malone-Group-Logo-B.png"
			[attr.x-contenttype]="'image/png'" title="Malone Group" class="logo" />
	</span>
</ng-template>
